<template>
  <div class="user">
    <!-- 旧的个人中心上部分 -->
    <div v-if="false" class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <!-- <div class="pictrue"><img :src="userInfo.avatar" /></div> -->
        <div class="text">
          <div class="acea-row row-middle page-relative">
            <div class="name line1" v-if="isHidenAccount">{{ userInfo.uname }}</div>
            <!-- 添加卡券按钮 -->
            <span class="add-con" v-if="isOpenAddCoupon" @click="closeAddCouponMask(true)">添加卡券</span>
            <!--  -->
            <span v-if="cardList.length >= 2 && isHidenAccount" class="page-absolute changeBtn" @click="changeAccountFn">切换点券</span>
            <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
            </div>
          </div>
          <div class="text">
          <div v-if="couponsList[0] && (couponsList[0].coupon_type == 2)" :style="{'overflow':'hidden','line-height':'40px'}">
              剩余兑换次数：
            <span v-if='userInfo.now_money > 0'>1</span>
            <span v-else>0</span>
              次 <span class="guoqi" v-if="couponsList[0] && (couponsList[0]._msg == '已过期') && isHidenAccount">已过期</span>
          </div>
<!--  -->
            <div class="num" :style="{'overflow':'hidden','line-height':'40px'}" v-else>
              <span v-if="userInfo.now_money">点券：{{ userInfo.now_money || 0 }}</span>
              <span class="guoqi" v-if="couponsList[0] && (couponsList[0]._msg == '已过期') && isNotWechat">已过期</span>

              <!-- <router-link class="gqcz"
              v-if="couponsList[0] && (couponsList[0]._msg == '已过期') && !isNotWechat"
              :style="{ 'color': '#fff', 'background':'#fc4141','height': '26px','line-height': '26px','padding': '0 10px',' border-radius': '6px!important',
    'margin': '5px 0 0 8px', 'display': 'inline-block' ,'float':'right'}"
              :to="{ path: '/user/account' }"
              >已过期点击充值激活</router-link> -->
              <div class="gqcz"
              v-if="couponsList[0] && (couponsList[0]._msg == '已过期') && !isNotWechat"
              :style="{ 'color': '#fff', 'background':'#fc4141','height': '26px','line-height': '26px','padding': '0 10px',' border-radius': '6px!important',
    'margin': '5px 0 0 8px', 'display': 'inline-block'}"
              >已过期</div>
              <!-- 充值功能所有用户隐藏 只显示过期字样-->
            </div>
            <span
              v-if="isHidenAccount"
              >{{ (couponsList[0] && couponsList[0].coupon_type) && (couponsList[0] && couponsList[0]._add_time) }}-{{
                couponsList[0] && couponsList[0]._end_time
              }}</span
            >
          </div>
        </div>
      </div>
      <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/data' })"
        v-if="false"
      ></span>
      <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/add_manage' })"
      ></span>
    </div>
    <!-- 新的个人中心上部分 -->
    <div class="newHeader">
        <div class="movie-box page-relative newTop">
          <!-- 点券/次券-券号-过期 -->
            <p> 
              <!-- 手机号登录 -->
              <span v-if="userInfo && userInfo.phone">{{userInfo.phone}}</span>
              <!-- 卡号登录 点券/次券 -->
              <span v-if="userInfo && !userInfo.phone && isHidenAccount">{{userInfo.uname}}</span>
              
              <!-- 点券 -->
              <span class="colorF6433D" v-if="couponsList[0] && (couponsList[0].coupon_type == 1) && (couponsList[0]._msg == '已过期')">（已过期）</span>
              <!-- 次券 -->
              <span class="colorF6433D" v-if="couponsList[0] && (couponsList[0].coupon_type == 2) && (couponsList[0]._msg == '已过期') && isHidenAccount">（已过期）</span>
            </p>
            <img class="page-absolute" @click="$router.push({ path: '/user/add_manage' })" src="@/assets/images/icon_address.png" />
        </div>
        <div class="page-relative newBottom">
            <!-- 头像 -->
            <div class="page-absolute headPortrait">
                <img :src="userInfo.avatar || require('@/assets/images/touxiang.png')" />
            </div>

            <!-- 手机登录 -->
            <div v-if="userInfo && userInfo.phone">
                <!-- 专区总余额 -->
                <!-- 次券专区 -->
                <p class="font-size24 colorFFD2D2 yue" v-if="couponsList[0] && (couponsList[0].coupon_type == 2)">可兑换<span class="font-size36">{{ userInfo.now_money || 0 }}</span>次</p>
                <!-- 点券专区 -->
                <p class="font-size24 colorFFD2D2 yue" v-else><span class="font-size36">{{ userInfo.now_money || 0 }}</span>点余额</p>
                <!-- 此专区绑定的卡券数量 -->
                <p class="font-size24 colorFFD2D2">可用卡券{{userInfo.cardNum || 0}}张</p>
            </div>

            <!-- 卡券登录 -->
            <div v-else>
              <!-- 兑换次数 次券-->
              <p class="font-size24 colorFFD2D2 yue" v-if="couponsList[0] && (couponsList[0].coupon_type == 2)">
                可兑换<span v-if='userInfo.now_money > 0'>1</span><span v-else>0</span>次
              </p>
              <!-- 余额 点券-->
              <p class="font-size24 colorFFD2D2 yue" v-else><span class="font-size36">{{ userInfo.now_money || 0 }}</span>点余额</p>
              <!-- 有效期 点券/次券-->
              <p class="font-size24 colorFFD2D2">有效期至：{{couponsList[0] && couponsList[0]._end_time}}</p>
            </div>
            
            <!-- 卡券管理 手机登录-->
            <div class="page-absolute page-text-center page-background-color-white font-size24 btn" v-if="userInfo && userInfo.phone" @click="changeProCouWin(true)">卡券管理</div>
            <!-- 绑定手机 点券/次券-->
            <div class="page-absolute page-text-center page-background-color-white font-size24 btn" v-if="userInfo && !userInfo.phone" @click="bindingPhone">绑定手机</div>

            <!-- 充值激活 部分点券过期展示-->
            <!-- <router-link :to="{ path: '/user/account', query: { id: userInfo.uname} }" v-if="couponsList[0] && (couponsList[0].coupon_type == 2) && (couponsList[0]._msg == '已过期') && !isNotWechat && userInfo.now_money > 0">
              <div class="page-absolute page-text-center page-background-color-white colorF6433D font-size24 btn btnRecharge">充值激活</div>
            </router-link> -->
            
        </div>
    </div>

    <div class="wrapper">
      <!-- <div class="nav acea-row row-middle" v-if="false">
        <router-link :to="{ path: '/user/account' }" class="item">
          <div>我的点券</div>
          <div class="num">{{ userInfo.now_money || 0 }}</div>
        </router-link>
        <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link>
      </div> -->
      <!-- 订单部分 -->
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>商城订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            查看全部<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/icon_daifukuan.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/icon_yifukuan.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>已付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/icon_yifahuo.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>已发货</div>
          </router-link>
          <router-link
            :to="{ path: '/order/list/' + 3 }"
            class="item"
            v-if="false"
          >
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item" v-if="true">
            <div class="pictrue">
              <img src="@assets/images/icon_shouhou.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div>
      <div class="myService" v-if="false">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>

    <!--<img src="@assets/images/support.png" class="support" />-->
    <div class="footer-line-height" v-if="false"></div>

    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>

    <div
      class="logOut cart-color acea-row row-center-wrapper bgdF6433D logoutbtn"
      @click="logout"
      v-if="isHidenAccount"
    >
      退出
    </div>

    <!-- 选卡券 -->
    <SwitchAccounts :showCard="showCard" :cardList="cardList" :title="currentAccount" @changeAccount="checkedCard"></SwitchAccounts>
  
    <!-- 新增某个区间用户可以在一个点券基础上叠加点券绑定 -->
    <AddCoupon @closeMask="closeAddCouponMask" :isShow="isShowAddCoupon" :currentCoupon="currentAccount" @success="User"></AddCoupon>
  
    <!-- 卡券管理 -->
    <ProductCouponWindow 
      :isOpen="isProCouWin" 
      :data="allCardList" 
      @closeAttr="changeProCouWin" 
      @removeCouFn="removeCouFn" 
      @addNewCoupon="addNewCoupon"
      @selectPartFn="selectPartFn"
     ></ProductCouponWindow>

    <!-- 新增卡券+绑定手机号 -->
     <BindCard :isShow="isAddNewCard" @submitFn="addNewCardCallback" @closeMaskFn="addNewCoupon" :isOpenPhone="isOpenPhone" @closeMaskPhone="openOrCloseBindingPhone" @mobileLogin="bindPhoneFn"></BindCard>
  
    <!-- 提示弹框 -->
    <SpringFrame ref="springFrame" :types="promptType" :content="promptContent" :btnCont="promptBtnCont" :isShow="promptIsShow" @closeMask="promptCloseMask" ></SpringFrame>
  </div>
</template>
<script>
import { getUser, getMenuUser, getLogout, getCouponsUser, getUserCoupon, loginCouponLogin, getAllUserCoupons, addNewCouponFn, removeCouponFn, addBindPhoneNumber } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import { clearAuthStatus } from "@libs/wechat";
import { switchH5Login } from "@api/user";
import cookie from "@utils/store/cookie";
import { timeFn } from "@utils/index.js";
import store from "@/store";
import dayjs from "dayjs";
import { islogin } from '../../api/user';
import SwitchAccounts from "@components/SwitchAccounts.vue";
import AddCoupon from "@components/AddCoupon.vue";
import ProductCouponWindow from "@components/ProductCouponWindow.vue";
import BindCard from "@/components/BindCard.vue";
import SpringFrame from "@/components/SpringFrame.vue";

const NAME = "User";
let change = null;

export default {
  name: NAME,
  components: {
    SwitchWindow,
    SwitchAccounts,
    AddCoupon,
    ProductCouponWindow,
    BindCard,
    SpringFrame
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      couponsList: [],
      cardList: [],
      showCard: false,
      currentAccount: "",
      _currentAccount: "",
      isNotWechat: false, //过期不能充值
      notWechatArray: [
        { minCoupon: 80016667, maxCoupon: 80017176},
        { minCoupon: 80021194, maxCoupon: 80021690},
        { minCoupon: 80023717, maxCoupon: 80024286},
        // 老年版--不组合支付
        { minCoupon: 80045574, maxCoupon: 80046813}
      ],
      //
      isShowAddCoupon: false,
      couponArray: [
        { minCoupon: "80020684", maxCoupon: "80020687"},
        { minCoupon: "80016562", maxCoupon: "80016640"},
        { minCoupon: "80018328", maxCoupon: "80020676"},
        { minCoupon: "80021188", maxCoupon: "80021191"},
        { minCoupon: "80020830", maxCoupon: "80021061"}
      ],
      isOpenAddCoupon: false, //展示添加卡券按钮
      isHidenAccount: true, //显示账号和有效期
      isProCouWin: false, // 卡券管理展示
      allCardList: [], // 手机绑定下的全部卡券专区
      isAddNewCard: false ,// 新增卡券
      // 提示弹窗
      promptType: '',
      promptContent: {
        title: '',
        tips: ''
      },
      prompt_id: '',//暂存
      promptIsShow: false,
      promptBtnCont: '',
      // 绑定手机号
      isOpenPhone: false,

    };
  },
  watch: {
    $route: function (n) {
      // console.log(change, n.name, "0000")
      if (n.name === NAME && change) {
        this.getData();
        if (this.showCard) {
          this.showCard = false;
        }
        change = false;
      }
      if (n.name === NAME) {
        if (this.showCard) {
          this.showCard = false;
        }
        this.User();
      }
      if (cookie.get('hide_other')) {
        this.isHidenAccount = false;
      } else {
        this.isHidenAccount = true;
      }
    }
  },
  mounted: function() {
    
    this.getData();
    if (cookie.get('hide_other')) {
      this.isHidenAccount = false;
    } else {
        this.isHidenAccount = true;
    }
    // getUser().then(res => {
    //   this.userInfo = res.data;
    //   console.log(this.userInfo);
    //   console.log(res.data);
    //   this.orderStatusNum = res.data.orderStatusNum;
    // });
  },
  methods: {
    // 绑手机
    bindPhoneFn(item) {
      let data = {
        phone: item.phoneNumber,
        captcha: item.smsVerCode
      };  
      addBindPhoneNumber(data).then((res)=>{
          if (res.status == 200) {
             this.$dialog.success(res.msg);
             cookie.set("couponId", this.userInfo.uname);
             this.openOrCloseBindingPhone(false);
             this.getData();
          }
       }).catch((err)=>{
         this.$dialog.error(err.msg);
       })
    },
    // 打开/关闭 - 绑卡弹窗
    openOrCloseBindingPhone(val) {
      this.isOpenPhone = val;
    },
    // 打开绑定手机弹框
    bindingPhone() {
       this.promptType = "type4";
       this.promptContent.title = "提示";
       this.promptContent.tips = "绑定手机号之后，此卡不能使用卡券登录，只能使用手机号登录";
       this.promptBtnCont = "";
       this.promptContent.sfDetermine = ()=>{
          this.promptCloseMask(false);
          this.openOrCloseBindingPhone(true);
       };
       this.promptCloseMask(true);
    },
    //
    selectPartFn(item) {
      let { id, kahao, cid } = item;
        this.prompt_id = cid;
        this.promptType = "type3";
        this.promptContent.title = "是否切换专区？";
        this.promptContent.tips = "";
        this.promptContent.sfDetermine = ()=>{
          // 切换专区 - 重新登录
          this.afresh();
          cookie.set("couponId", kahao);
          this.promptCloseMask(false);
          this.promptType = "";
          this.promptContent.title = "";
        };
        this.promptBtnCont = "";
        this.promptCloseMask(true);
    },
    // 绑定卡券
    addNewCardCallback(value) {
        let data = {
          account: value.account, 
          password: value.passWord
        };
        addNewCouponFn(data).then((res)=>{
            if (res.status == 200) {
              this.addNewCoupon(false);
              this.$dialog.success(res.msg);
              setTimeout(async()=>{
                await this.getAllCouponData();
                await this.User();
              }, 2000)
            }
        }).catch((err)=>{
          if (err.data.status == 400 && err.msg == "该卡券已被绑定") {
            this.prompt_id = "";
            this.promptType = "type2";
            this.promptContent.title = err.data.data.title;
            this.promptContent.tips = err.data.data.desc;
            this.promptContent.sfDetermine = ()=>{
              this.promptCloseMask(false);
              this.promptType = "";
              this.promptContent.title = "";
              this.promptContent.tips = "";
              this.promptBtnCont = "";
            };
            this.promptBtnCont = "确定";
            this.promptCloseMask(true);
          } else {
            this.$dialog.error(err.msg);
          }
        })
    },
    // 新增卡券
    addNewCoupon(val) {
        this.isAddNewCard = val;
    },
    // 解绑卡券
    removeCouFn(id) {
      this.prompt_id = id;
      this.promptType = 'type4';
      this.promptContent.title = "确定解绑该卡券？";
      this.promptContent.tips = "解绑卡券后只能使用卡券密码进行登录";
      this.promptContent.sfDetermine = ()=>{
          this.promptCloseMask(false);
          removeCouponFn(this.prompt_id).then((res)=>{
              if (res.status == 200) {
                this.$dialog.success(res.msg);
                setTimeout(async ()=>{
                    await this.getAllCouponData();
                    await this.User();
                }, 2000)
              } else {
                this.$dialog.error(res.msg);
              }
          }).catch((err)=>{
              this.$dialog.error(err.msg);
          })
      };
      this.promptCloseMask(true);
    },
    // 关闭/打开弹窗 - 取消按钮
    promptCloseMask(val) {
        this.promptIsShow = val;
    },
    afresh() {
       this.$dialog.loading.open("正在切换请稍后...");
      loginCouponLogin({id: this.prompt_id}).then((res)=>{
        if(!res.data) return;
        this.$dialog.loading.close();
        let data = res.data;
        this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
        this.$dialog.success("切换成功！");
        this.changeProCouWin(false);
        this.getData();
        // this.$router.push({name: "Index", params: { id: "0"}});
      }).catch((err)=>{
        this.$dialog.loading.close();
        console.log(err);
        this.currentAccount = this._currentAccount;
        this.$dialog.error("切换失败");
      });
    },
    changeProCouWin: function (val) {
       if (val) {
         this.getAllCouponData();
       } else {
         this.isProCouWin = val;
       }
    },
    getAllCouponData() {
      let that = this;
          this.$dialog.loading.open("正在加载中, 请勿重复点击");
           getAllUserCoupons().then((res)=>{
             this.$dialog.loading.close();
            if (res.status == 200) {
               let name = res.data && Object.keys(res.data) || []
               let data = res.data && Object.values(res.data) || [];

               // 添加一个当前专区的信息 isCurrent==true/false
               let current_id = cookie.get("couponId") || this.userInfo.uname;

               data && data.forEach((item, ind)=>{
                   item.title = name[ind] || '';
                   if (ind == 0) {
                     item.isOpen = true;
                   } else {
                     item.isOpen = false;
                   }

                   let _currentIs = false;
                   item.child.forEach((val)=>{
                       
                      //不能充值区间
                    let user_id = val.title;
                    for(let i = 0; i < that.notWechatArray.length; i++) {
                      if (user_id >= that.notWechatArray[i].minCoupon && user_id <= that.notWechatArray[i].maxCoupon) {
                        val.isNotWechat = true;
                      } else if ( user_id == 80021690 || user_id == 80021689) {
                        val.isNotWechat = true;
                      } else {
                        val.isNotWechat = false;
                      }
                    }
                      //是否所在当前专区
                      if (val.coupon_title == current_id) {
                        _currentIs = true;
                      }
                   })
                    item.isCurrent = _currentIs;
               });
               if (data.length == 1 && data[0] && data[0].child.length == 1) {
                 // 只绑定了一个专区且只有一张卡 不能解绑
                 data[0].isone = true;
               }
              //  console.log(data, "data");
               that.allCardList = data;
               that.isProCouWin = true;
            }
         }).catch((err)=>{
            this.$dialog.loading.close();
            that.$dialog.error(err);
         })
    },
    //
    closeAddCouponMask: function (val) {
      this.isShowAddCoupon = val;
    },
    getData: async function () {
      await getCouponsUser(0).then(res => {
        this.couponsList = res.data;
        this._currentAccount = res.data[0].coupon_title;
        this.currentAccount = res.data[0].coupon_title;
        //是否为某个区间用户，展示添加卡券的按钮,使之可以叠加卡券使用
        let card = res && res.data && res.data[0] && res.data[0].coupon_title || "";
        
        let isFalse = false;
        for(let i = 0; i<this.couponArray.length; i++) {
          if (card >= this.couponArray[i].minCoupon && card <= this.couponArray[i].maxCoupon) {
            isFalse = true;
          }
        }

        if (isFalse) {
          this.isOpenAddCoupon = true;
        } else {
          this.isOpenAddCoupon = false;
        }
      });
      await this.User();
      this.MenuUser();
      // 切换点券功能
      // this.getUserCouponFn();
      this.isWeixin = isWeixin();
    },
    getUserCouponFn: function () {
      getUserCoupon().then((res)=>{
        // console.log(res,"卡券");
          let data = res.data;
          let arr = [];
          data.forEach((item)=>{
            arr.push({
              coupon_price: item.coupon_price,
              id: item.id,
              cate_name: item.cate_name,
              imgUrl: item.imgUrl,
              type: item.type,
              title: item.title
            })
          })
          this.cardList = arr;
      }).catch((err)=>{
        console.log(err,"err");
      })
    },
    changeAccountFn: function () { //点击切换点券
        this.showCard = true;
    },
    checkedCard: function (val) {
       let { id, showCard, title} = val;

      this.$dialog.loading.open("正在切换请稍后...");
      
      loginCouponLogin({id: id}).then((res)=>{
        if(!res.data) return;
        this.$dialog.loading.close();
        this.showCard = showCard;
        this.currentAccount = title;
        let data = res.data;
        change = true;
        this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
        this.$dialog.success("切换成功！");
        this.$router.push({name: "Index", params: { id: "0"}});
      }).catch((err)=>{
        this.$dialog.loading.close();
        console.log(err);
        this.showCard = false;
        this.currentAccount = this._currentAccount;
        this.$dialog.error("切换失败");
      });

    },

    logout: function() {
      this.$dialog.confirm({
        mes: "确认退出登录?",
        opts: () => {
          // getLogout()
          //   .then(res => {
          //     this.$store.commit("LOGOUT");
          //     // clearAuthStatus();
          //     location.href = location.origin;
          //     // location.href = "/";
          //     console.log(res);
          //   })
          //   .catch(err => {
          //     console.log(err);
          //     location.href = location.origin;
          //   });
          islogin({islogin:2})
          .then(res=>{
              console.log(res)
              this.$store.commit("LOGOUT");
              if (cookie.get("loginphone")) {
                location.href = location.origin+'/loginphone';
              } else {
                location.href = location.origin;
              }
          })
          .catch(err => {
              console.log(err);
              if (cookie.get("loginphone")) {
                location.href = location.origin+'/loginphone';
              } else {
                location.href = location.origin;
              }
          });
        }
      });
    },
    switchAccounts: function(index) {
      let that = this;
      this.userIndex = index;
      let userInfo = this.switchUserInfo[this.userIndex];
      if (this.switchUserInfo.length <= 1) return true;
      if (userInfo === undefined)
        return this.$dialog.toast({ mes: "切换的账号不存在" });
      if (userInfo.user_type === "h5") {
        switchH5Login()
          .then(({ data }) => {
            that.$dialog.loading.close();
            const expires_time = dayjs(data.expires_time);
            store.commit("LOGIN", data.token, expires_time);
            that.$emit("changeswitch", false);
            location.reload();
          })
          .catch(err => {
            that.$dialog.loading.close();
            return that.$dialog.toast({ mes: err });
          });
      } else {
        cookie.set("loginType", "wechat", 60);
        this.$dialog.loading.close();
        this.$store.commit("LOGOUT");
        clearAuthStatus();
        this.$emit("changeswitch", false);
        location.reload();
      }
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        // console.log(that.userInfo);
        // console.log(res.data);
        that.orderStatusNum = res.data.orderStatusNum;

        //不能充值区间
        let user_id = res.data && res.data.uname;
        let isTrue = false;
        for(let i = 0; i < this.notWechatArray.length; i++) {
          if (user_id >= this.notWechatArray[i].minCoupon && user_id <= this.notWechatArray[i].maxCoupon) {
            isTrue = true;
          } else if ( user_id == 80021690 || user_id == 80021689 || user_id == 80039795 ) {
            isTrue = true;
          }
        }
        if (isTrue) {
            this.isNotWechat = true;
          } else {
            this.isNotWechat = false;
          }
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
        if (!this.userInfo.is_promoter)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }

      this.$router.push({ path: this.MyMenus[index].wap_url });
    }
  }
};
</script>

<style scoped lang="scss">
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  color: #fff;
  background: #F6433D;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #F6433D;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
.serviceList .item:first-child {
  display: none;
}
.num .gqcz{
  border-radius:6px;
}

/*  */
.changeBtn {
  left: 1.6rem;
  color: #fff;
  border: .02rem solid #fff;
  padding: .02rem .04rem;
  border-radius: .1rem;
}
.add-con {
  color: #fff;
  background: #fc4141;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  border-radius: 6px!important;
  margin: 0 0 0 8px;
  display: inline-block ;
  float: right;
}

/*  */
.newHeader {
  width: 100%;
  /* height: 3.02rem; */
  padding: 0 0.2rem;
  margin-bottom: 0.32rem;
  background: linear-gradient(180deg, #FEEEE1 0%, rgba(249,236,226,0.81) 49%, rgba(228,228,228,0) 100%);
}
.newTop {
    padding-top: 0.46rem;
    padding-left: 2.08rem;
    height: .96rem;
    img {
      width: 0.36rem;
      height: 0.36rem;
      top: 0.46rem;
      right: 0;
    }
}
.newBottom {
  width: 100%;
  height: 2.06rem;
  background:url("../../assets/images/user_background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .headPortrait {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    background: linear-gradient(318deg, #FD625D 0%, #FF6C67 100%);
    transform: translate(0%, -50%);
    left: 0.32rem;
    img {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 50%;
      margin-top: 0.1rem;
      margin-left: 0.1rem;
    }
  }
  p {
    margin-left: 0.42rem;
  }
  .yue {
    padding-top: 1rem;
    margin-bottom: 0.1rem;
  }
  .btn {
    width: 1.52rem;
    height: 0.48rem;
    border-radius: 0.24rem;
    line-height: 0.48rem;
    right: 0.32rem;
    bottom: 0.22rem;
  }
  .btnRecharge {
    right: 2.04rem;
  }
}
</style>
